import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, Button, Box } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import { useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { formatDateTime, formatDateWithJs, isNotEmpty } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery, useQueryClient } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert, notify } from "../../../components/notify";
import { getNotApprDeptServ } from "../../../services/com-service";
import { approveDeptServ } from "../../../services/dept-service";


const deptCols = [
  {
    id: 'actProjIdStrg',
    label: "Project ID",
    align: 'left',
    minWidth: 50
  },
  {
    id: 'projName',
    label: "Project Name",
    align: 'left',
    minWidth: 150
  },
  {
    id: 'deptName',
    label: "Department Name",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'cAt',
    label: "Created At",
    align: 'left',
    minWidth: 150,
  },
  {
    id: 'btn',
    label: "",
    align: 'center',
    minWidth: 50
  }
];




function NotApprDept({ aComId }) {
  const { setLoadingScreen } = useAuthContext();
  const limit = 7
  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
  const comId = aComId
  const queryClient = useQueryClient();


  const { isLoading, isError, error, data: deptData } = useQuery([QueryKey.notApprEmp, pgNo, comId, isSrchBtnClick],
    () => getNotApprDeptServ({ comId, limit, pageNumber: pgNo, searchWord }), {
    enabled: isNotEmpty(comId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    keepPreviousData: true
  });



  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  async function onSearchBtnClick(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }



  async function handleDeptApproveClick(deptId) {
    setLoadingScreen(true);
    try {
      const { message } = await approveDeptServ(deptId);
      notify("success", message);
      queryClient.invalidateQueries();
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  }


  const handlePageChange = async (event, value) => {
    //    setPageNumber(value);
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }
  return (
    <Box height={"90%"} width={"100%"} px={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
        <Stack width={"20%"} >
          <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Employee List</Typography>
        </Stack>
        <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={400}>
          <SearchTxtField width={"100%"} handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick}
            placeholder="Search Emp By Project Id / Department Name..." />
        </Stack>
        <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"20%"} >

        </Stack>
      </Stack>

      {deptData && <StyledTableContainer height={"81%"} isStickyHeader={true}>
        <TableHead>
          <TableRow >
            {deptCols.map((column) => (
              <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{
                backgroundColor: "rgba(253, 240, 213, 1)"
              }}>
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(deptData?.deptArr || []).map((i, ind) => {
            return (
              <React.Fragment key={`_${ind}`}>
                <TableRow hover tabIndex={-1} sx={{ height: 50 }} >
                  {deptCols.map((column, index) => {
                    const value = i[column.id];
                    switch (column.id) {
                      case "btn":
                        return <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                          <Button variant='contained' onClick={() => handleDeptApproveClick(i?.id)} sx={{
                            fontSize: 13, color: "white", bgcolor: "green", height: 30
                          }}>
                            Approve</Button>
                        </TableCell>
                      case "cAt":
                        return (
                          <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {formatDateTime(value)}
                          </TableCell>
                        );
                      default:
                        return (
                          <TableCell key={index} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                            {(value === null || value === "" || value === "null") ? "NA" : value}
                          </TableCell>
                        );
                    }
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </StyledTableContainer>}
      <Stack sx={{ alignItems: "center", mt: 2 }}>
        <Pagination count={Math.ceil(deptData?.totalDeptCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
          variant="outlined" shape="rounded" />
      </Stack>

    </Box>
  );
}


export default NotApprDept;